import { ExternalConnection, ExternalConnectionsStatuses } from '@griply/types';

export const isConnectionBroken = (connection: ExternalConnection): boolean =>
  connection.status === ExternalConnectionsStatuses.Broken;
